import { currencyFormatter, dateFormatter } from "utils/helpers";

export const ModeList = [
  { value: "all", label: "All" },
  { value: "Badge", label: "Badge" },
  { value: "Cash", label: "Cash" },
  { value: "Card", label: "Card" },
  { value: "Online", label: "Online" },
];

const ModeMap = {
  "Online Order": "Online",
  "Badge":"Badge",
  "Credit Card": "Card",
  "Debit Card": "Card",
  Cash: "Cash",
};

export const fields = [
  {
    key: "device__serial_number",
    columnName: "Serial Number",
    type: "text",
    visible: true,
    render: (_, rec) => rec?.device_serial || "---",
  },
  {
    key: "device__vm_name",
    columnName: "VM Name",
    type: "text",
    visible: true,
    render: (_, rec) => rec?.vm_name || "---",
  },
  {
    key: "transaction_id",
    columnName: "Transaction Id",
    type: "text",
    visible: true,
    render: (val) => val || "---",
  },
  {
    key: "order",
    columnName: "Order Id",
    type: "text",
    visible: true,
    render: (_, rec) => rec?.order_id || "---",
  },
  {
    key: "type",
    columnName: "Type",
    type: "text",
    visible: true,
    disableSorting: true,
    render: (_, rec) => rec?.type || "---",
  },
  {
    key: "mode",
    columnName: "Mode",
    type: "text",
    visible: true,
    disableSorting: true,
    render: (_, rec) => (rec?.mode ? ModeMap[rec.mode] || "---" : "---"),
  },
  {
    key: "status",
    columnName: "Status",
    type: "text",
    visible: true,
    render: (val) => val,
  },
  {
    key: "gateway",
    columnName: "Gateway",
    type: "text",
    visible: true,
    render: (val) => val,
  },
  {
    key: "amount",
    columnName: "Amount",
    type: "text",
    visible: true,
    render: (val) => currencyFormatter(val),
  },
  {
    key: "order_date",
    columnName: "Time",
    type: "text",
    visible: true,
    render: (val) => dateFormatter(val, true) || "---",
  },
];
